// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 공통 페이지 레이아웃 */
.page-layout {
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: #f5f6fa;
  overflow: hidden;
}

/* 화면명 */
.page-title-bar {
  flex-shrink: 0;
  padding: 8px 20px 6px;
  background-color: #fff;
  border-bottom: 2px solid #e0e4ef;
}

.page-title-bar h2 {
  margin: 0;
  font-size: 1.05rem;
  font-weight: 700;
  color: #1a1a2e;
}

/* 조회 조건 영역 */
.page-toolbar {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 20px;
  background-color: #f8f9fc;
  border-bottom: 1px solid #e0e4ef;
}

/* 데이터 그리드 영역 - 나머지 공간 전부 사용 */
.page-body {
  flex: 1 1;
  min-height: 0;
  overflow: hidden;
  padding: 12px 20px;
  display: flex;
  flex-direction: column;
}

/* 세로 스크롤 허용 (투자종합현황 등 내용이 길어지는 화면) */
.page-body-scroll {
  overflow-y: auto;
}

/* 하단 메시지 영역 - 항상 고정 (레이아웃 변경 없음) */
.page-message-bar {
  flex-shrink: 0;
  height: 30px;
  line-height: 30px;
  padding: 0 20px;
  font-size: 12px;
  font-weight: 500;
  background-color: #f0f2f8;
  border-top: 1px solid #e0e4ef;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  transition: background-color 0.2s, color 0.2s;
}

.page-message-bar.msg-success {
  background-color: #d4edda;
  color: #155724;
}

.page-message-bar.msg-error {
  background-color: #f8d7da;
  color: #721c24;
}

.page-message-bar.msg-info {
  background-color: #cce5ff;
  color: #004085;
}

.page-message-bar.msg-warn {
  background-color: #fff3cd;
  color: #856404;
}

/* ── 공통 그리드 스타일 (모든 화면에서 재사용) ── */

/* 그리드 래퍼 - 스크롤 컨테이너 */
.grid-wrapper {
  flex: 1 1;
  min-height: 0;
  overflow: auto;
  border: 1px solid #dde2ef;
  border-radius: 4px;
  background: white;
}

/* 공통 테이블 */
.grid-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
  white-space: nowrap;
}

/* 헤더 고정 (상하 스크롤 시 컬럼명 고정) */
.grid-table thead tr {
  position: sticky;
  top: 0;
  z-index: 2;
  background-color: #f0f2f8;
}

.grid-table th {
  padding: 7px 10px;
  text-align: left;
  font-weight: 600;
  color: #444;
  font-size: 12px;
  border-bottom: 2px solid #dde2ef;
  border-right: 1px solid #e8eaf0;
}

.grid-table th:last-child {
  border-right: none;
}

.grid-table td {
  padding: 5px 10px;
  border-bottom: 1px solid #f0f0f0;
  border-right: 1px solid #f5f5f5;
  color: #333;
}

.grid-table td:last-child {
  border-right: none;
}

.grid-table tbody tr {
  cursor: pointer;
  transition: background-color 0.1s;
}

.grid-table tbody tr:hover {
  background-color: #f5f7ff;
}

.grid-table tbody tr.selected {
  background-color: #e8edff;
}

/* 좌측 고정 컬럼 (freeze) */
.grid-table th.col-freeze,
.grid-table td.col-freeze {
  position: sticky;
  z-index: 1;
  background: inherit;
}

.grid-table thead th.col-freeze {
  z-index: 3;
}

/* 데이터 없을 때 */
.grid-empty {
  text-align: center;
  color: #aaa;
  padding: 40px !important;
  cursor: default !important;
}

/* 텍스트 정렬 헬퍼 */
.col-center { text-align: center !important; }
.col-right  { text-align: right  !important; }

/* 공통 버튼 (PageLayout 사용 화면에서 재사용) */
.btn {
  padding: 6px 14px;
  border: none;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.2s;
}

.btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.btn-primary   { background-color: #1a1a2e; color: white; }
.btn-secondary { background-color: #e0e4ef; color: #444;  }
.btn-danger    { background-color: #e74c3c; color: white; }

.btn-primary:hover:not(:disabled)   { background-color: #16213e; }
.btn-secondary:hover:not(:disabled) { background-color: #d0d5e8; }
.btn-danger:hover:not(:disabled)    { background-color: #c0392b; }

.btn-sm { padding: 3px 9px; font-size: 11px; }
`, "",{"version":3,"sources":["webpack://./src/components/PageLayout.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA,QAAQ;AACR;EACE,cAAc;EACd,qBAAqB;EACrB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,aAAa;AACb;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA,8BAA8B;AAC9B;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;AACxB;;AAEA,qCAAqC;AACrC;EACE,gBAAgB;AAClB;;AAEA,mCAAmC;AACnC;EACE,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,mCAAmC;;AAEnC,sBAAsB;AACtB;EACE,SAAO;EACP,aAAa;EACb,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,WAAW;AACX;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,mBAAmB;AACrB;;AAEA,4BAA4B;AAC5B;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,gCAAgC;EAChC,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,+BAA+B;EAC/B,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,sBAAsB;AACtB;;EAEE,gBAAgB;EAChB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA,aAAa;AACb;EACE,kBAAkB;EAClB,WAAW;EACX,wBAAwB;EACxB,0BAA0B;AAC5B;;AAEA,cAAc;AACd,cAAc,6BAA6B,EAAE;AAC7C,cAAc,6BAA6B,EAAE;;AAE7C,mCAAmC;AACnC;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA,iBAAiB,yBAAyB,EAAE,YAAY,EAAE;AAC1D,iBAAiB,yBAAyB,EAAE,WAAW,GAAG;AAC1D,iBAAiB,yBAAyB,EAAE,YAAY,EAAE;;AAE1D,sCAAsC,yBAAyB,EAAE;AACjE,sCAAsC,yBAAyB,EAAE;AACjE,sCAAsC,yBAAyB,EAAE;;AAEjE,UAAU,gBAAgB,EAAE,eAAe,EAAE","sourcesContent":["/* 공통 페이지 레이아웃 */\n.page-layout {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  background-color: #f5f6fa;\n  overflow: hidden;\n}\n\n/* 화면명 */\n.page-title-bar {\n  flex-shrink: 0;\n  padding: 8px 20px 6px;\n  background-color: #fff;\n  border-bottom: 2px solid #e0e4ef;\n}\n\n.page-title-bar h2 {\n  margin: 0;\n  font-size: 1.05rem;\n  font-weight: 700;\n  color: #1a1a2e;\n}\n\n/* 조회 조건 영역 */\n.page-toolbar {\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 20px;\n  background-color: #f8f9fc;\n  border-bottom: 1px solid #e0e4ef;\n}\n\n/* 데이터 그리드 영역 - 나머지 공간 전부 사용 */\n.page-body {\n  flex: 1;\n  min-height: 0;\n  overflow: hidden;\n  padding: 12px 20px;\n  display: flex;\n  flex-direction: column;\n}\n\n/* 세로 스크롤 허용 (투자종합현황 등 내용이 길어지는 화면) */\n.page-body-scroll {\n  overflow-y: auto;\n}\n\n/* 하단 메시지 영역 - 항상 고정 (레이아웃 변경 없음) */\n.page-message-bar {\n  flex-shrink: 0;\n  height: 30px;\n  line-height: 30px;\n  padding: 0 20px;\n  font-size: 12px;\n  font-weight: 500;\n  background-color: #f0f2f8;\n  border-top: 1px solid #e0e4ef;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  transition: background-color 0.2s, color 0.2s;\n}\n\n.page-message-bar.msg-success {\n  background-color: #d4edda;\n  color: #155724;\n}\n\n.page-message-bar.msg-error {\n  background-color: #f8d7da;\n  color: #721c24;\n}\n\n.page-message-bar.msg-info {\n  background-color: #cce5ff;\n  color: #004085;\n}\n\n.page-message-bar.msg-warn {\n  background-color: #fff3cd;\n  color: #856404;\n}\n\n/* ── 공통 그리드 스타일 (모든 화면에서 재사용) ── */\n\n/* 그리드 래퍼 - 스크롤 컨테이너 */\n.grid-wrapper {\n  flex: 1;\n  min-height: 0;\n  overflow: auto;\n  border: 1px solid #dde2ef;\n  border-radius: 4px;\n  background: white;\n}\n\n/* 공통 테이블 */\n.grid-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 12px;\n  white-space: nowrap;\n}\n\n/* 헤더 고정 (상하 스크롤 시 컬럼명 고정) */\n.grid-table thead tr {\n  position: sticky;\n  top: 0;\n  z-index: 2;\n  background-color: #f0f2f8;\n}\n\n.grid-table th {\n  padding: 7px 10px;\n  text-align: left;\n  font-weight: 600;\n  color: #444;\n  font-size: 12px;\n  border-bottom: 2px solid #dde2ef;\n  border-right: 1px solid #e8eaf0;\n}\n\n.grid-table th:last-child {\n  border-right: none;\n}\n\n.grid-table td {\n  padding: 5px 10px;\n  border-bottom: 1px solid #f0f0f0;\n  border-right: 1px solid #f5f5f5;\n  color: #333;\n}\n\n.grid-table td:last-child {\n  border-right: none;\n}\n\n.grid-table tbody tr {\n  cursor: pointer;\n  transition: background-color 0.1s;\n}\n\n.grid-table tbody tr:hover {\n  background-color: #f5f7ff;\n}\n\n.grid-table tbody tr.selected {\n  background-color: #e8edff;\n}\n\n/* 좌측 고정 컬럼 (freeze) */\n.grid-table th.col-freeze,\n.grid-table td.col-freeze {\n  position: sticky;\n  z-index: 1;\n  background: inherit;\n}\n\n.grid-table thead th.col-freeze {\n  z-index: 3;\n}\n\n/* 데이터 없을 때 */\n.grid-empty {\n  text-align: center;\n  color: #aaa;\n  padding: 40px !important;\n  cursor: default !important;\n}\n\n/* 텍스트 정렬 헬퍼 */\n.col-center { text-align: center !important; }\n.col-right  { text-align: right  !important; }\n\n/* 공통 버튼 (PageLayout 사용 화면에서 재사용) */\n.btn {\n  padding: 6px 14px;\n  border: none;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: opacity 0.2s;\n}\n\n.btn:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.btn-primary   { background-color: #1a1a2e; color: white; }\n.btn-secondary { background-color: #e0e4ef; color: #444;  }\n.btn-danger    { background-color: #e74c3c; color: white; }\n\n.btn-primary:hover:not(:disabled)   { background-color: #16213e; }\n.btn-secondary:hover:not(:disabled) { background-color: #d0d5e8; }\n.btn-danger:hover:not(:disabled)    { background-color: #c0392b; }\n\n.btn-sm { padding: 3px 9px; font-size: 11px; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
